import React from 'react';
import { View } from 'react-native-web';
import {
  addPathToList,
  Automatic_defined_services,
  File_type_PNG,
  file_type_stickers,
  keyboard_promotional_screens,
  menu_screenshot,
  promotional_screen_3,
  promotional_screen_menu,
  screens_automatically_added,
  security_str,
  select_promotional_screens,
  Sticker_row_small,
  stickers_gifs,
  Stickers_str,
  Upload_assets,
  Upload_image,
} from '../utils/DictionaryManagementUtils';
import FullPagePanel from '../components/PanelsComponents/General/FullPagePanel';
import BreakLine from '../components/PanelsComponents/General/BreakLine';
import Title from '../components/PanelsComponents/Text/Title';
import RadioPanel from '../components/PanelsComponents/Buttons/RadioPanel';
import Paragraph from '../components/PanelsComponents/Text/Paragraph';
import UploadMenu from '../components/PanelsComponents/Upload/UploadMenu';

//= ========================================================================
const Panel_V02_promotion = ({
  globJSON,
  selectedScreen,
  onConfigChanged,
  onStepPressed,
  language,
}) => {
  const isScreen3Security = globJSON.configurations.onboarding.promotion.onboarding_screen_3_is_security;
  const editTextList = [
    'promo_text_1',
    'promo_text_2',
    isScreen3Security ? 'promo_text_4' : 'promo_text_3',
    'o_a_button_title',
    'maybe_later',
  ];
  const listObjectA = [
    {
      subHeadline: menu_screenshot,
      fileId: 'configurations/onboarding/promotion/menu_screenshot',
    },
  ];
  const listObjectB = [
    {
      subHeadline: Stickers_str,
      fileId: 'configurations/onboarding/promotion/onboarding_big_stickers',
    }, {
      subHeadline: Sticker_row_small,
      fileId: 'configurations/onboarding/promotion/onboarding_small_stickers',
    },
  ];
  const { promotion } = globJSON.configurations.onboarding;
  const { onboarding_screen_2_is_automatic } = promotion;
  const { onboarding_screen_3_is_security } = promotion;
  const onValueChanged = (key, value) => {
    promotion[key] = value;
    onConfigChanged();
  };

  return (
    <FullPagePanel
      globJSON={globJSON}
      onConfigChanged={onConfigChanged}
      selectedScreen={selectedScreen}
      onStepPressed={onStepPressed}
      panelHeadline={keyboard_promotional_screens}
      paragraph={select_promotional_screens}
      editTextList={addPathToList(editTextList, 'configurations/onboarding/promotion/')}
      tooltipsTitles={globJSON.configurations.onboarding.screens_ordering}
      language={language}
      paddingVertical={25}
      isHollow
    >
      <BreakLine />
      <Title isBold>{promotional_screen_menu}</Title>
      <RadioPanel
        value={onboarding_screen_2_is_automatic}
        headlineLeftOption={Automatic_defined_services}
        headlineRightOption={Upload_image}
        onPressLeftOption={() => onValueChanged('onboarding_screen_2_is_automatic', true)}
        onPressRightOption={() => onValueChanged('onboarding_screen_2_is_automatic', false)}
        language={language}
      />
      {!onboarding_screen_2_is_automatic
            && (
            <View>
              <UploadMenu
                globJSON={globJSON}
                onConfigChanged={onConfigChanged}
                details={File_type_PNG}
                listObject={listObjectA}
              />
            </View>
            )}
      <Title isBold>{promotional_screen_3}</Title>
      <Paragraph marginBottom={16}>{screens_automatically_added}</Paragraph>
      <RadioPanel
        value={onboarding_screen_3_is_security}
        headlineLeftOption={security_str}
        headlineRightOption={stickers_gifs}
        onPressLeftOption={() => onValueChanged('onboarding_screen_3_is_security', true)}
        onPressRightOption={() => onValueChanged('onboarding_screen_3_is_security', false)}
        language={language}
      />
      {!onboarding_screen_3_is_security
            && (
            <View>
              <BreakLine />
              <UploadMenu
                globJSON={globJSON}
                onConfigChanged={onConfigChanged}
                headline={Upload_assets}
                details={file_type_stickers}
                listObject={listObjectB}
                TwoButtonsInARow
              />
            </View>
            )}
    </FullPagePanel>
  );
};

export default Panel_V02_promotion;
